import type { Components, Theme } from "@mui/material/styles";

export const MuiPopover: Components<Theme>["MuiPopover"] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      backgroundColor: theme.palette.common.white,
    }),
  },
};
